export const getUserRoutes = ({ urlPrefix = "" }) => {
  return [
    {
      title: "Profile",
      route: urlPrefix,
    },
    {
      title: "Administration",
      route: urlPrefix + "/administration",
    },
    {
      title: "Subscription",
      route: urlPrefix + "/subscription",
    },
  ]
}
